import {
    Menu as UiMenu,
    MenuItem as UiMenuItem,
    ListItemText as UiListItemText,
    styled,
} from "@mui/material"

const MENU_MAX_WIDTH = 280
const MENU_ITEM_HEIGHT = 42

export const Menu = styled(UiMenu)(({ theme }) => ({
    "& .MuiMenu-paper": {
        overflow: "hidden",
        marginTop: theme.spacing(1),
        borderRadius: theme.spacing(3),
        boxShadow: theme.shadows[33],
        maxWidth: MENU_MAX_WIDTH,

        "& .MuiList-root": {
            paddingTop: 0,
            paddingBottom: 0,
        },
    },
}))

export const MenuItem = styled(UiMenuItem)(() => ({
    height: MENU_ITEM_HEIGHT,
}))

export const ListItemText = styled(UiListItemText)(() => ({
    "& .MuiTypography-root": {
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
    },
}))